import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarBlockTextComponent } from './avatar-block-text.component';
import { AvatarBlockComponent } from './avatar-block.component';
import { AvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule],
  exports: [AvatarComponent, AvatarBlockComponent, AvatarBlockTextComponent],
  declarations: [
    AvatarComponent,
    AvatarBlockComponent,
    AvatarBlockTextComponent
  ],
  providers: []
})
export class AvatarModule {}
